// widgets/chart/ui/DefaultChartWidget.tsx

import {FC, ReactNode} from 'react';
import {
  DefaultChartWidgetProps,
  SparklineWidgetProps,
  ColumnWidgetProps,
  ColumnDualWidgetProps,
} from 'widgets/chart/model/types';
import {ActiveSparkline} from 'widgets/chart/ui/ActiveSparkline';
import {ActiveColumn} from 'widgets/chart/ui/ActiveColumn';
import {ActiveColumnDual} from 'widgets/chart/ui/ActiveColumnDual';
import {InactiveSparkline} from 'widgets/chart/ui/InactiveSparkline';
import {InactiveColumn} from 'widgets/chart/ui/InactiveColumn';

export const DefaultChartWidget: FC<DefaultChartWidgetProps> = (props) => {
  if (!props.isActive) {
    if (props.type === 'sparkline') return <InactiveSparkline />;
    return <InactiveColumn />;
  }

  let content: ReactNode = null;

  switch (props.type) {
    case 'sparkline': {
      const p = props as SparklineWidgetProps;
      content = (
        <ActiveSparkline
          data={p.data}
          seriesLabel={p.seriesLabel ?? ''}
          width={p.width}
          height={p.height}
          marks={p.marks}
          thresholds={p.thresholds}
          showAxes={p.showAxes}
          fillFuture={p.fillFuture}
          periodForFill={p.periodForFill}
          tooltipText={p.tooltipText}
          xTicks={p.xTicks}
          xTickFormatter={p.xTickFormatter}
          xDomain={p.xDomain}
          currentDate={p.currentDate}
          showPoints={true}
        />
      );
      break;
    }

    case 'column': {
      const p = props as ColumnWidgetProps;
      content = (
        <ActiveColumn
          data={p.data}
          seriesLabel={p.seriesLabel ?? ''}
          width={p.width}
          height={p.height}
          marks={p.marks}
          thresholds={p.thresholds}
          showAxes={p.showAxes}
          fillFuture={p.fillFuture}
          periodForFill={p.periodForFill}
          highlightLast={p.highlightLast}
          showDiff={p.showDiff}
          diffLegendLabels={p.diffLegendLabels}
          tooltipText={p.tooltipText}
          xTicks={p.xTicks}
          xTickFormatter={p.xTickFormatter}
          xDomain={p.xDomain}
          currentDate={p.currentDate}
        />
      );
      break;
    }

    case 'column2': {
      const p = props as ColumnDualWidgetProps;
      content = (
        <ActiveColumnDual
          data={p.data}
          data2={p.data2}
          seriesLabels={p.seriesLabels ?? {first: '', second: ''}}
          width={p.width}
          height={p.height}
          marks={p.marks}
          thresholds={p.thresholds}
          showAxes={p.showAxes}
          fillFuture={p.fillFuture}
          periodForFill={p.periodForFill}
          highlightLast={p.highlightLast}
          tooltipText={p.tooltipText}
          xTicks={p.xTicks}
          xTickFormatter={p.xTickFormatter}
          xDomain={p.xDomain}
        />
      );
      break;
    }
  }

  return <>{content}</>;
};
